import type { SVGProps } from "react";

/**
 * sparkle, star, ai
 * @category AI & Magic
 */
export default function IconSparkle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.25 12C14.8264 12 12 14.8264 12 21.25C12 14.8264 9.17361 12 2.75 12C9.17361 12 12 9.17361 12 2.75C12 9.17361 14.8264 12 21.25 12Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    </svg>
  );
}
